import React, { Component } from "react";
import Accordion from 'react-bootstrap/Accordion';

export default class Culture extends Component {
  render() {
    return (

      <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>饮茶礼仪</Accordion.Header>
        <Accordion.Body  >
        中国是茶叶的故乡，有着悠久的种茶历史，严格的敬茶礼节，
        奇特的饮茶风俗。中国饮茶，从神农时代开始，有四千七百多年历史。
        茶礼有缘，古已有之。客来敬茶，是中国汉族最早重情好客的传统美德与礼节。
        直到21世纪，宾客至家，总要沏上一杯香茗。喜庆活动，也喜用茶点招待。
        开个茶话会，既简便经济，又典雅庄重。所谓君子之交淡如水，也是指清香宜人的茶水。
        中国汉族还有种种以茶代礼的风俗。南宋都城杭州，每逢立夏，家家各烹新茶，
        并配以各色细果，馈送亲友毗邻，叫做七家茶。这种风俗，
        就是在茶杯内放两颗青果即橄榄或金桔，表示新春吉祥如意的意思。 
        茶礼还是中国古代婚礼中一种隆重的礼节的。
        明·许次纾在《茶疏考本》中说：茶不移本，植必子生。
        古人结婚以茶为识，以为茶树只能从种子萌芽成株，不能移植，
        否则就会枯死，因此把茶看作是一种至性不移的象征。
        所以，民间男女订婚以茶为礼，女方接受男方聘礼，叫下茶或茶定，
        有的叫受茶，并有一家不吃两家茶的谚语。同时，还把整个婚姻的礼仪总称为三茶六礼。
        三茶，就是订婚时的下茶，结婚的定茶，同房时的合茶。下茶又有男茶女酒之称，即定婚时，
        男家除送如意压帖外，要回送几缸绍兴酒。婚礼时，还要行三道茶仪式。三道茶者，第一杯百果，
        第二杯莲子、枣儿；第三杯方是茶。吃的方式，接杯之后，双手捧之，深深作揖，然后向嘴唇一触，
        即由家人收去。第二道亦如此。第三道，作揖后才可饮。这是最尊敬的礼仪。这些繁俗，
        有婚礼的敬茶之礼，仍沿用成习。张源《茶录》“汤辨”条载：“汤有三大辨十五辨。
        一曰形辨，二曰声辨，三曰气辨。”
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>存储方法</Accordion.Header>
        <Accordion.Body>
        1．有条件的可将装入铁罐内的茶叶用抽气机抽去罐内空气，再焊好封口，如此可贮藏茶叶二三年，
        如条件不够，可用热水瓶胆贮藏，因为水瓶胆与外界空气隔绝，茶叶装入胆内，加塞盖严后，
        以白蜡封口，外包胶布，简单易行，易于家庭保管。<br/>
        2．普通的瓶、罐等保管茶叶，用设有内外双层盖或以口小腹大的陶罐为好，可以减少容器内的空气接触，
        容器盖要与容器身结合严密，以防止湿气进入。<br/>
        3．茶叶的包装材料要求无异味，盛茶容器和使用方法上要尽可能密闭，有良好的防潮性能，减少与空气接触，
        要求存放在干燥、清洁、无异味的地方。<br/>
        4．利用冷藏室或电冰箱贮藏，贮藏时注意将茶叶密封后再放入。<br/>
        5．用生石灰或高级干燥剂，如硅胶吸收茶叶中的水分，保藏效果较好。<br/>
        6．利用罐内空气稀薄及密封后罐内茶叶与外界隔绝原理，将茶叶烘干到含水量在2%左右趁热立即装入罐内，
        然后再密封，在常温下也可贮藏一二年。
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>

    

    );
  }
}